export default "__VITE_ASSET__DtYFQp0G__"